import { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { addLocalRecentHistoryItem } from 'dibs-recent-history/exports/addLocalRecentHistoryItem';

export class PdpSharedRecentHistoryTrackerComponent extends Component {
    componentDidMount() {
        const { item } = this.props;
        addLocalRecentHistoryItem(item);
    }

    render() {
        return null;
    }
}

PdpSharedRecentHistoryTrackerComponent.propTypes = {
    item: PropTypes.object,
};

export const PdpSharedRecentHistoryTracker = createFragmentContainer(
    PdpSharedRecentHistoryTrackerComponent,
    {
        item: graphql`
            fragment PdpSharedRecentHistoryTracker_item on Item {
                ...addLocalRecentHistory_item @relay(mask: false)
            }
        `,
    }
);
